module.exports = __webpack_public_path__ + "static/media/suitcase.ba58016b.svg";